import React from 'react';
import classnames from 'classnames';
import invariant from 'invariant';
import stylesheet from './Lozenge.scss';

export const asTypes = {
  'solid-teal': 'solid-teal',
  'solid-teal-200': 'solid-teal-200',
  'solid-purple': 'solid-purple',
  'solid-neutral-dark-500': 'solid-neutral-dark-500',
  'solid-volcano': 'solid-volcano',
  'solid-blue': 'solid-blue',
  'solid-red': 'solid-red',
  'outline-teal': 'outline-teal',
  'outline-purple': 'outline-purple',
  'outline-neutral-dark-500': 'outline-neutral-dark-500',
  'outline-volcano': 'outline-volcano',
  'outline-blue': 'outline-blue',
  'outline-red': 'outline-red',
};

export const invariantMessage =
  'You must specify a valid value for the "as" prop when rendering a Lozenge';

export const Lozenge = ({ children, as }) => {
  invariant(asTypes[as], invariantMessage);

  const lozengeClass = classnames(
    stylesheet.lozenge,
    stylesheet[`lozenge--${as}`]
  );

  return <div className={lozengeClass}>{children}</div>;
};

export default Lozenge;
